import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export function InvestInvestors() {
  return <section aria-labelledby="current-investors" className="bg-white border-t border-line py-16 lg:py-20" data-id="element-731" data-mp="vywjch2ev60">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-732" data-mp="3s2jiwiw6dewp">
        <div className="lg:col-span-5" data-id="element-733" data-mp="3o1zohn2zkpe9">
          <h2 id="current-investors" className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-734" data-mp="3j1v61riipkle">
            Current investors
          </h2>
        </div>
        <div className="lg:col-span-7 space-y-5 lg:pt-2" data-id="element-735" data-mp="394h04lu80e7c">
          <p className="text-xl text-ink-dark leading-relaxed" data-id="element-736" data-mp="1cb5f2jxi69nt">
            The California Institute for Microbiome Research (CalMiR) is
            SyNeural’s main investor. CalMiR focuses on microbiome and wellness
            research, including testing claims, developing and validating
            protocols, and translating research into health applications. Its
            broader work connects research, product development, certification,
            and outreach.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-737" data-mp="gkjxuq6whx59">
            Microbiome research illustrates a practical application for
            SyNeural: connecting knowledge about organisms, conditions,
            interventions, study populations, and outcomes while preserving
            supporting sources and review history.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-738" data-mp="zg0a8qxpaodz">
            CalMiR’s backing reflects a shared interest in making complex
            scientific knowledge easier to examine, connect, and apply.
          </p>
          <a href="https://calmir.org" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 pt-1 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-739" data-mp="1s4e733d1zeny">
            Learn more about CalMiR
            <ArrowUpRight size={18} aria-hidden="true" data-id="element-740" data-mp="21ri62qchlbfi" />
            <span className="sr-only" data-id="element-741" data-mp="1xqeqm4ycphet">(opens calmir.org in a new tab)</span>
          </a>
        </div>
      </motion.div>
    </section>;
}